import React from 'react';

import type { VirtualNodeProps } from '@gitbook/slate-react';
import { VirtualizedCodeBlockLine } from '@gitbook/spine-react';

export const VirtualBlockCodeLine = React.memo(function VirtualBlockCodeLine(
    props: VirtualNodeProps
) {
    return (
        <VirtualizedCodeBlockLine ref={props.domRef} {...props}>
            {props.children}
        </VirtualizedCodeBlockLine>
    );
});
